// src\components\Header\Header.jsx

import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import './Header.css';
import UserAuthService from '../../services/UserAuthService';

const Header = ({ notifications, setNotifications }) => {
  // State variables
  const [showNotifications, setShowNotifications] = useState(false);
  const ref = useRef(null);

  // Handle click outside notifications
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setShowNotifications(false);
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  // Clear notifications
  const clearNotifications = () => {
    setNotifications([]); // Clear the notifications state
  };

  // Sign out function
  async function handleSignOut() {
    try {
      await UserAuthService.signOut();
      // Redirect to login page or handle post-logout logic here
      console.log('Successfully signed out');
    } catch (err) {
      console.error('Failed to sign out:', err);
    }
  }

  return (
    <div className="app-header" ref={ref}>
      {/* Newly added Sign out button */}
      <button type="button" onClick={handleSignOut}>
        Sign Out
      </button>
      
      <button type="button" onClick={clearNotifications}>
        Clear Notifications
      </button>
      
      {/* Existing notification-related code */}
      <div
        className="notification-icon"
        onClick={() => setShowNotifications(!showNotifications)}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            setShowNotifications(!showNotifications);
          }
          if (e.ctrlKey && e.shiftKey && e.key === 'E') {
            console.log('Custom key combination Ctrl+Shift+E pressed');
          }
        }}
      >
        {notifications.length > 0 && (
          <span className="badge">{notifications.length}</span>
        )}
        {showNotifications && (
          <div className="notifications-list">
            {notifications.map((notification) => (
              <div key={`notification-${notification.id}`} className="notification-item">
                {notification.message}
              </div>
            ))}
            <hr />
            <button type="button" className="notification-clear" onClick={clearNotifications}>
              Clear Notifications
            </button>
          </div>
        )}
      </div>

      {/* Add the new buttons for Home, Settings, and 128k */}
      <div className="header-buttons">
        <button type="button" onClick={() => { window.location.href = '/'; }}>Home</button>
        <button type="button" onClick={() => { window.location.href = '/settings'; }}>Settings</button>
        <button type="button" onClick={() => { window.open('https://chat4-128k.vercel.app/', '_blank'); }}>128k</button>
        <button type="button" onClick={() => { window.open('https://www.robo-kitty.com/', '_blank'); }}>FatCat128</button>
      </div>
    </div>
  );
};

Header.propTypes = {
  notifications: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      message: PropTypes.string.isRequired,
    }),
  ).isRequired,
  setNotifications: PropTypes.func.isRequired,
};

export default Header;
